import {} from 'react';
import ReactDOM from 'react-dom';
import {IntlProvider, useIntl} from 'react-intl';

import {messages, locale} from '@/locales';
import sdk from '@/sdk';
import * as store from '@/store';
import {SinglePersonData} from '@/interface';
import {
    shareInviteDisplayType,
    ShareInviteModalSource,
    ShareInviteModalType,
} from '@/Constant';
import {feLogger, lineationCommentShare} from '@/buried';
import Dialog2 from '@/components/Dialog2';
import toast, {ToastType} from '@/components/Toast';
import ShareSearchPopper from '@/components/shareCollaborate/search/searchContent';

import styles from './index.module.scss';
import kuPiper from '@/middleware/kuPiper';

const shareLinkToRuLiu = kuPiper.runProxy(kuPiper.proxyNameMap.forwardCommentNotifyProxy, (url, users, ksServer) => {
    return ksServer.shareLinkToRuLiu(url, users);
});

interface IProps {
    url: string;
    onClose?: () => void;
}
// 评论的分享弹窗组件
const ShareDialog: React.FC<IProps> = ({url, onClose}) => {
    const intl = useIntl();

    async function share(users: SinglePersonData[]) {
        feLogger(lineationCommentShare());
        const ksServer = await sdk.getKsServer();
        return shareLinkToRuLiu(url, users.map((user) => {
            return {
                chatId: user.gid || user.rlId,
                chatType: user.gid ? 2 : 1,
                name: user.name || user.nickname,
                avatar: user.avatar,
                email: user.email,
            };
        }), ksServer).then(() => {
            toast({
                type: ToastType.Success,
                content: intl?.formatMessage({id: 'toastShareSuccess'}),
            });
            onClose && onClose();
        }).catch(() => {
            toast({
                type: ToastType.Error,
                content: intl?.formatMessage({id: 'toastShareFailed'}),
            });
        });
    }

    const repository = store.getCurRepository();
    const doc = store.getCurDocument();
    return <Dialog2 className={styles.dialog} visible showFooter={false}>
        <ShareSearchPopper
            title="分享链接到如流"
            repository={repository!}
            docGuid={doc?.docGuid}
            shareContent={url}
            shareInviteConfig={{
                source: ShareInviteModalSource.recentDocs,
                type: ShareInviteModalType.share,
                displayType: shareInviteDisplayType.popper,
            }}
            showCancel
            showClose
            handleClose={onClose}
            externalShareMethod={share}
        />
    </Dialog2>;
};

export function shareToRuLiu(url: string) {
    let rootEl: HTMLDivElement | null = document.createElement('div');
    document.body.appendChild(rootEl);

    function remove() {
        if (rootEl) {
            ReactDOM.unmountComponentAtNode(rootEl);
            document.body.removeChild(rootEl);
            rootEl = null;
        }
    }

    ReactDOM.render(<IntlProvider locale={locale} messages={messages.zh}>
        <ShareDialog url={url} onClose={remove} />
    </IntlProvider>, rootEl);
}
